import { render, staticRenderFns } from "./SubmitCancelRow.vue?vue&type=template&id=1fd01c3b&scoped=true&"
import script from "./SubmitCancelRow.vue?vue&type=script&lang=js&"
export * from "./SubmitCancelRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd01c3b",
  null
  
)

export default component.exports